import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * A soft, luxury-tone marketing panel that projects a 10–15% studio courtesy
 * for early bookings. Written to feel like an invitation, not a sale.
 * Placed near the bottom of the Home page above the final CTA.
 */
export default function StudioNote() {
  return (
    <section
      className="bg-[hsl(var(--bg-alt))] py-24 md:py-32"
      data-testid="studio-note"
    >
      <div className="mx-auto max-w-[1200px] px-6 md:px-10 grid md:grid-cols-12 gap-10 md:gap-16 items-center">
        <div className="md:col-span-5 reveal">
          <div className="kicker text-[hsl(var(--accent))]">A note from the studio</div>
          <h2 className="font-display text-3xl md:text-5xl mt-6 leading-[1.05]">
            <span className="italic">10–15%</span> saved, quietly.
          </h2>
          <p className="mt-4 text-[hsl(var(--ink-soft))] text-sm md:text-base italic">
            For hosts who dream early.
          </p>
        </div>

        <div className="md:col-span-7 space-y-6 text-[hsl(var(--ink-soft))] leading-relaxed reveal">
          <p>
            We reserve a small number of dates each season for couples and hosts who reach out
            before their calendar is fully claimed. Those bookings carry a{" "}
            <strong className="text-[hsl(var(--ink))]">studio courtesy of 10–15% on
            planning fees</strong> — our quiet way of honouring the families who trust us from
            the very first conversation.
          </p>
          <p>
            No coupon codes. No countdowns. Just a phone call, a walkthrough of your vision,
            and — if your date is one of ours — a lighter invoice at the end of it.
          </p>

          <div className="pt-4 flex flex-wrap items-center gap-6">
            <Link
              to="/contact"
              data-testid="studio-note-cta"
              className="inline-flex items-center gap-2 bg-[hsl(var(--ink))] text-[hsl(var(--bg))] px-6 py-3 text-[11px] tracking-[0.3em] uppercase hover:bg-[hsl(var(--accent))] transition-colors duration-500"
            >
              Ask Shubhra how to save <ArrowRight size={14} />
            </Link>
            <span className="text-[10px] tracking-[0.25em] uppercase text-[hsl(var(--ink-soft))]">
              Applied at consultation · Subject to availability
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
